import React, { ReactNode } from "react";
import "./commonlayout.scss";
function CommonLayout({ children }: { children: ReactNode }) {
  return <div className="common-layout">{children}</div>;
}

export default CommonLayout;
